import './ActionTemplateCard.scss';

import classNames from 'classnames';
import React from 'react';
import { SonarText } from '@ui/text';
import { StackIcon } from '@ui/icons';

import { BankOutlined, FileOutlined, HistoryOutlined, TeamOutlined } from '@ant-design/icons';
import { Card, Flex, Tag } from 'antd';
import { DataSecurityMonitorType, RecommendedActionTemplate } from '@sonar-software/sonar-core';

export const labelMetaLookup: Record<string, {
	color: string,
	icon: React.ReactNode,
	monitorType?: DataSecurityMonitorType
}> = {
	'Data Dictionary': {
		color: 'purple',
		icon: <BankOutlined />
	},
	'New User': {
		color: 'green',
		icon: <TeamOutlined />,
		monitorType: DataSecurityMonitorType.NewUser
	},
	'Object and Field Access': {
		color: 'cyan',
		icon: <StackIcon />,
		monitorType: DataSecurityMonitorType.ConfigurableFieldAccess
	},
	'Setup Audit Trail': {
		color: 'orange',
		icon: <FileOutlined />,
		monitorType: DataSecurityMonitorType.SetupAuditTrail
	},
	'Uptime': {
		color: 'magenta',
		icon: <HistoryOutlined />,
		monitorType: DataSecurityMonitorType.Uptime
	}
};

export type ActionTemplateCardProps = RecommendedActionTemplate & {
	onClick?: (id: number) => void
};

export const ActionTemplateCard: React.FC<ActionTemplateCardProps> = ({
	description,
	disabled,
	id,
	label,
	name,
	onClick
}) => {
	const { color, icon } = labelMetaLookup[ label ] ?? {};

	return (
		<Card
			className={ classNames('action-template-card', { disabled: disabled }) }
			hoverable={ !disabled }
			onClick={ () => !disabled && onClick?.(id) }>
			<Tag
				className='template-icon-area'
				color={ color }
				icon={ icon } />
			<Flex
				className='action-template-card-content'
				vertical>
				<Tag
					className='action-template-label'
					color={ color }>{ label }
				</Tag>
				<h3>{ name }</h3>
				<SonarText>{ description }</SonarText>
			</Flex>
		</Card>
	);
};
